import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col } from 'reactstrap';
import BaseComponent from './BaseComponent';
import NumberFormat from 'react-number-format';
import * as CONSTANTS from '../../../../../../../common/utils/data_validations';
import { useState } from 'react';
import { handleKeyDown } from 'helpers/quote_funnel_helper';

/**
 * PhoneComponent is a reusable React component that renders a form component field with an associated label and tooltip.
 * 
 * @param {Object} props - The props for the PhoneComponent.
 * @param {Object} props.label - An object containing properties related to the label.
 * @param {string} props.label.name - The name of the label.
 * @param {string} props.label.tooltip - The tooltip message for the label.
 * @param {Object} props.component - An object containing properties related to the component field.
 * @param {string} props.component.id - The ID of the component field.
 * @param {string} props.component.name - The name of the component field.
 * @param {string} props.component.type - The type of the component field (default is 'text').
 * @param {Object} props.validation - An object containing form validation properties.
 * @param {Function} props.validation.handleChange - The function to handle component changes.
 * @param {Function} props.validation.handleBlur - The function to handle component blur.
 * @param {Object} props.validation.values - An object containing form values.
 * @param {Object} props.validation.touched - An object indicating whether fields have been touched.
 * @param {Object} props.validation.errors - An object containing validation errors.
 * 
 * @returns {JSX.Element} - A React component that renders a component field with label and tooltip.
 */
const PhoneComponent = ({ index, question, onChangeEvent }) => {
    const [isValidPhoneNum, setIsValidPhoneNum] = useState(true);
    const handlePhoneChange = async (e) => {
        const numericValue = e.target.value.replace(/\D/g, '');
        onChangeEvent(numericValue);
        const isPhoneNumValid = (CONSTANTS.phoneRegExp).test(numericValue)
        setIsValidPhoneNum(isPhoneNumValid);
    };

    return (
        <BaseComponent question={question}>
            <Row key={index}>
                <Col md={12} className='mb-2'>
                    <NumberFormat
                        id={question?.id || ''}
                        name={question?.field_name || ''}
                        className={`quote-funnel-form-control text-center`}
                        placeholder='(xxx) xxx-xxxx'
                        value={question?.value || ''}
                        autoFocus={true}
                        onKeyDown={handleKeyDown}
                        onChange={handlePhoneChange}
                        format="(###) ###-####"
                    />
                </Col>
            </Row>
        </BaseComponent>
    );

}

PhoneComponent.propTypes = {
    label: PropTypes.object,
    component: PropTypes.object,
    validation: PropTypes.object,
};

export default PhoneComponent;
